import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const TermsConditions: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Terms & Conditions: Ieshia Danielle"
        description="Terms and conditions of service for using iamieshiadanielle.com."
        canonical="https://iamieshiadanielle.com/terms"
      />
      <div className="min-h-screen bg-[#FAF6F0] text-[#380C1E] flex flex-col font-sans">
        <Header />
        <main className="flex-1 py-16 md:py-24 px-4">
          <div className="max-w-4xl mx-auto bg-white/70 backdrop-blur-md border border-[#E8DEC8] p-8 md:p-12 rounded-3xl shadow-sm">
            <p className="text-xs uppercase font-semibold tracking-widest text-[#9E1B50] mb-2">
              IESHIA DANIELLE
            </p>
            <h1 className="font-serif text-3xl md:text-5xl font-normal text-[#380C1E] mb-4">
              Terms & Conditions
            </h1>
            <p className="text-xs text-[#380C1E]/70 mb-8 font-medium">
              Effective date: July 25, 2026 | Last updated: August 10, 2026
            </p>

            <div className="space-y-6 text-sm md:text-base leading-relaxed text-[#380C1E]/90 font-light">
              <p>
                Welcome. These Terms & Conditions ("Terms") govern your use of
                iamieshiadanielle.com and its connected pages — including the
                shop, quiz, order pages, From Burnout to Becoming workbook
                pages, Becoming Intensive enrollment pages, and speaking/booking
                pages operated by Ieshia Danielle ("we," "us," or "our").
              </p>
              <p>
                By using the Site, making a purchase, taking the quiz, or
                submitting any form, you agree to these Terms, our Privacy
                Policy, and our Return & Refund Policy.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                1. Who May Use the Site
              </h2>
              <p>
                You must be at least 18 years old to make a purchase on the
                Site.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                2. Products, Programs & Orders
              </h2>
              <p>
                We offer physical products, digital resources, the Becoming
                Intensive group program, and speaking services. Prices and
                availability are subject to change.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                3. Payments & Payment Plans
              </h2>
              <p>
                Payment is due at checkout. Choosing a payment plan is a
                commitment to pay the full program price, not a subscription you
                can cancel partway.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                4. Returns & Refunds
              </h2>
              <p>
                All sales are final except as expressly provided in our Return &
                Refund Policy.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                5. Intellectual Property
              </h2>
              <p>
                All content, materials, frameworks (including the 6 B's
                framework, Reset Framework, and quiz names), and logos are owned
                by Ieshia Danielle. You may not copy, share, teach, or create
                derivative works without prior written authorization.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                6. Contact Us
              </h2>
              <p>
                <strong>Ieshia Danielle</strong>
                <br />
                Email:{" "}
                <a
                  href="mailto:admin@mail.iamieshiadanielle.com"
                  className="text-[#9E1B50] underline"
                >
                  admin@mail.iamieshiadanielle.com
                </a>
              </p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default TermsConditions;
